import { useErrorBoundary } from 'react-error-boundary';
import { useMemo, useContext, createContext } from 'react';

import { handleError } from '../handle-error';

const ErrorBoundaryContext = createContext({
  showBoundary: (error: any) => handleError(error),
});

export const ErrorBoundaryProvider = ({ children }: { children: React.ReactNode }) => {
  const { showBoundary } = useErrorBoundary();

  // useMemo를 사용하여 value 객체를 메모이제이션
  const contextValue = useMemo(() => ({ showBoundary }), [showBoundary]);

  return (
    <ErrorBoundaryContext.Provider value={contextValue}>{children}</ErrorBoundaryContext.Provider>
  );
};

export const useErrorBoundaryContext = () => useContext(ErrorBoundaryContext);
